export default __webpack_public_path__ + "static/107979-cc27fe0d01f84c81e94a79eb05dc72e1.jpg";